import { render, staticRenderFns } from "./ed-section-course-materials.vue?vue&type=template&id=7fd537de&scoped=true&"
import script from "./ed-section-course-materials.ts?vue&type=script&lang=ts&"
export * from "./ed-section-course-materials.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-course-materials.scss?vue&type=style&index=0&id=7fd537de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd537de",
  null
  
)

export default component.exports